// FikoSahne - Point cloud desteği ve TWEEN animasyonu (güncelleme: 2026-02-01)
// import { Subscription } from "rxjs";
import * as THREE from "three";
import * as BufferGeometryUtils from 'three/examples/jsm/utils/BufferGeometryUtils.js'
import { FikoThreeJsComponent } from "../fiko-three-js.component";
import { FikoCizimYalin } from "./FikoCizimYalin";
import { FikoObje3D } from "./FikoObje3D";
import { FikoUrunAgaci } from "./FikoUrunAgaci";
import { FikoSecililer } from "./FikoSecililer";
// import { FikoProfil2d } from "./FikoThreeCam/FikoProfil2d";
// import { FikoTakimYolu } from "./FikoThreeCam/FikoTakimYolu";

declare var TWEEN: any;

export class FikoSahne extends THREE.Scene {
    [x: string]: any;
    override type: any = "FikoSahne";
    urunAgaci = new FikoUrunAgaci(this, "FikoYT Ürün Ağacı");
    /** */
    // public secililer: FikoObje3D[] = [];
    /** */
    // public secimFilitresi: ["Hepsi" | "FikoEksen"] = ["Hepsi"];
    // public secilenler: FikoObje3D[] = [];
    /** */
    // dc: Subscription;
    public secimler: FikoSecililer;

    /**
     * FikoSahne constructor
     *
     * Seçim sistemi konfigürasyonu:
     * - odakAktif = true: Hover sırasında otomatik olarak yüzey/çizgi/nokta highlight yapılır
     * - Sistem aktif iken (secimler.aktif = true) mouse hover sırasında görsel feedback verilir
     *
     * Örnek kullanım:
     * ```typescript
     * // Hover highlight'ı devre dışı bırak
     * scene.secimler.odakAktif = false;
     *
     * // Hover highlight'ı etkinleştir
     * scene.secimler.odakAktif = true;
     * ```
     */
    constructor(public anaGosterim?: FikoThreeJsComponent) {
        super();
        this.ekle(this.anaGosterim.aktifKamera);
        this.ekle(this.urunAgaci);

        // FikoSecililer sistemi konfigürasyonu
        this.secimler = new FikoSecililer(
            anaGosterim,
            this.children,
            "*",    // Tüm nesneleri seç
            true,   // odakAktif: true ise hover highlight yapılır
            true    // cokluSecim
        );
        this.secimler.aktif = false;  // başlangıçta kapalı
        this.ekle(this.secimler);

        this.background = null;


        // const helper = new THREE.CameraHelper(this.anaGosterim.aktifKamera);
        // this.ekle(helper);

        // let lamba2 = new THREE.DirectionalLight(0xffffff);
        // lamba2.position.set(-100, 100, 1000);
        // lamba2.position.set(100, -100, 1000);
        // lamba2.shadow.mapSize.width = 1024;
        // lamba2.shadow.mapSize.height = 1024;

        // lamba2.intensity = 2;
        // lamba2.shadow.camera.near = 500;
        // lamba2.shadow.camera.far = 2000;
        // // lamba2.shadow.camera.fov = 30;
        // this.anaGosterim.aktifKamera.add(lamba2);
        // lamba2.position.set(0, 0, 5000);
        // lamba2.target = this.anaGosterim.aktifKamera;

        /**
         * 
        */



        // let light = new FikoIsikYonsel(this,"FikoAnaIşık.1");
        // this.add(light);
        // light.castShadow = true;
        // light.position.set(0, 0, 1);
        // this.anaGosterim.aktifKamera.add(light)


        /**
         * 
         */




        // light.target = this.anaGosterim.aktifKamera;
        /** */
        /** */
        // let light1 = new THREE.DirectionalLight(0xffffff, .1);
        // light1.castShadow = true;
        // this.add(light1);
        // light1.position.set(1000, 1000, 5000);
        // /** */
        // /** */
        // let light2 = new THREE.DirectionalLight(0xffffff, .1);
        // light2.castShadow = true;
        // this.add(light2);
        // light2.position.set(-1000, -1000, -5000);
        // /** */
        // /** */
        // let light3 = new THREE.DirectionalLight(0xffffff, .1);
        // light3.castShadow = true;
        // this.add(light3);
        // light3.position.set(0, 500, 5000);
        /** */
        /** */
        // let light4 = new THREE.DirectionalLight(0xffffff, 1);
        // light4.castShadow = true;
        // this.add(light4);
        // light4.position.set(0, 500, 0);

        // anaGosterim.renderListeners.set("kontrolUpdate", this.anaGosterim.aktifKontrol.addEventListener("change", () => {
        //     // light.position.set(0, 0, 1);
        //     // light.target = this.anaGosterim.aktifKamera;
        //     // anaGosterim.aktifKamera.updateMatrix();
        //     // anaGosterim.aktifKamera.updateMatrixWorld();
        //     // anaGosterim.aktifKamera.updateProjectionMatrix();
        //     anaGosterim?.ciz();
        // }));

        this.matrixAutoUpdate = false;
        // this.autoUpdate = false;
    }


    ekle?(...objeler: THREE.Object3D[]): FikoSahne {
        super.add(...objeler);

        objeler.forEach((element: any) => {
            element.traverse((obj: any) => {
                if (obj.hazirla) {
                    obj.hazirla(this);
                }
                // 🔥 FIX: FikoEksen eklendiğinde overlay cache'i invalidate et
                if (obj.type === 'FikoEksen') {
                    this.anaGosterim?.invalidateEksenCache?.();
                }
            })
        });
        return this;
    }

    override clone(recursive?: boolean) {
        let kopya = super.clone(true);
        (kopya as FikoSahne).anaGosterim = this.anaGosterim;
        return kopya;
    }

    normalizeGeometries(geometries: THREE.BufferGeometry[]): THREE.BufferGeometry[] {
        const tumAttrBilgileri = new Map<string, number>(); // attrName => itemSize

        // 1. Tüm attribute isimlerini ve boyutlarını topla (ilk karşılaşılanı baz al)
        for (const g of geometries) {
            for (const attrName in g.attributes) {
                const attr = g.getAttribute(attrName);
                if (!tumAttrBilgileri.has(attrName)) {
                    tumAttrBilgileri.set(attrName, attr.itemSize);
                }
            }
        }

        const attrIsimleri = Array.from(tumAttrBilgileri.keys());

        // 2. Eksik olan attribute'ları dummy verilerle doldur
        return geometries.map((geometry) => {
            const g = geometry.index ? geometry.toNonIndexed() : geometry;
            const posAttr = g.getAttribute("position");
            const vertexCount = posAttr.count;

            for (const attrName of attrIsimleri) {
                const itemSize = tumAttrBilgileri.get(attrName)!;
                if (!g.hasAttribute(attrName)) {
                    const dummy = new Float32Array(vertexCount * itemSize);
                    for (let i = 0; i < dummy.length; i++) {
                        dummy[i] = (attrName === "alpha") ? 1 : 0.5; // alpha için 1, diğerleri gri
                    }
                    g.setAttribute(attrName, new THREE.Float32BufferAttribute(dummy, itemSize));
                } else {
                    const mevcut = g.getAttribute(attrName);
                    if (mevcut.itemSize !== itemSize) {
                    }
                }
            }

            return g;
        });
    }


    ekranaSigdir(obj?: THREE.Object3D, ayar?: {
        paddingOrani?: number,
        animasyonSuresiMs?: number,
        otomatikDondur?: boolean
    }) {
        // console.log('[ekranaSigdir] Başladı, hedef:', obj?.name || 'sahne');

        if (typeof TWEEN === 'undefined') {
            console.warn('[ekranaSigdir] TWEEN tanımlı değil!');
            return;
        }

        const hedefObj = obj || this;
        const padding = ayar?.paddingOrani ?? 0.2;
        const animSuresi = ayar?.animasyonSuresiMs ?? 500;
        const dondur = ayar?.otomatikDondur ?? false;

        const geometriler: THREE.BufferGeometry[] = [];
        const pointCloudGeometriler: THREE.BufferGeometry[] = [];
        const pointCloudMatrices: THREE.Matrix4[] = [];

        hedefObj.traverse((elm: any) => {
            if (elm.type === "FikoCizimYalin") {
                const child = (elm as FikoCizimYalin).children[0];
                if (child instanceof THREE.Mesh && child.geometry) {
                    geometriler.push(child.geometry.clone());
                }
            } else if (elm instanceof THREE.Mesh && elm.geometry) {
                // console.log('[ekranaSigdir] Mesh bulundu:', elm.name);
                geometriler.push(elm.geometry.clone());
            } else if (elm instanceof THREE.Points && elm.geometry) {
                // Point Cloud desteği - ayrı listede tut + world matrix kaydet
                // console.log('[ekranaSigdir] Points bulundu:', elm.name, 'nokta sayısı:', elm.geometry.attributes?.position?.count);
                elm.updateMatrixWorld(true);
                pointCloudGeometriler.push(elm.geometry);
                pointCloudMatrices.push(elm.matrixWorld.clone());
            }
        });

        // console.log('[ekranaSigdir] Mesh sayısı:', geometriler.length, 'Points sayısı:', pointCloudGeometriler.length);

        // Hiç geometri yoksa çık
        if (geometriler.length === 0 && pointCloudGeometriler.length === 0) {
            console.warn('[ekranaSigdir] Hiç geometri bulunamadı!');
            return;
        }

        let boundingSphere: THREE.Sphere | null = null;

        // Sadece point cloud varsa, doğrudan bounding sphere hesapla
        if (geometriler.length === 0 && pointCloudGeometriler.length > 0) {
            // Position attribute'lardan doğrudan box hesapla (world matrix uygulanmış)
            const min = new THREE.Vector3(Infinity, Infinity, Infinity);
            const max = new THREE.Vector3(-Infinity, -Infinity, -Infinity);
            const tempVec = new THREE.Vector3();

            for (let g = 0; g < pointCloudGeometriler.length; g++) {
                const pcGeom = pointCloudGeometriler[g];
                const worldMatrix = pointCloudMatrices[g];
                const posAttr = pcGeom.getAttribute('position');
                if (posAttr) {
                    // console.log('[ekranaSigdir] Point cloud işleniyor, nokta sayısı:', posAttr.count);
                    for (let i = 0; i < posAttr.count; i++) {
                        tempVec.set(posAttr.getX(i), posAttr.getY(i), posAttr.getZ(i));
                        tempVec.applyMatrix4(worldMatrix); // World matrix uygula
                        min.x = Math.min(min.x, tempVec.x);
                        min.y = Math.min(min.y, tempVec.y);
                        min.z = Math.min(min.z, tempVec.z);
                        max.x = Math.max(max.x, tempVec.x);
                        max.y = Math.max(max.y, tempVec.y);
                        max.z = Math.max(max.z, tempVec.z);
                    }
                }
            }

            // Geçerli box varsa sphere oluştur
            if (min.x !== Infinity) {
                const center = new THREE.Vector3().addVectors(min, max).multiplyScalar(0.5);
                const radius = min.distanceTo(max) / 2;
                boundingSphere = new THREE.Sphere(center, radius);
                // console.log('[ekranaSigdir] Point cloud bounds:', { min: min.toArray(), max: max.toArray(), center: center.toArray(), radius });
            } else {
                console.warn('[ekranaSigdir] Point cloud için geçerli bounds bulunamadı');
            }
        }
        // Sadece mesh varsa eski yöntem
        else if (geometriler.length > 0 && pointCloudGeometriler.length === 0) {
            const duzenlenmisGeometriler = this.normalizeGeometries(geometriler);
            const birlesikGeometry = BufferGeometryUtils.mergeGeometries(duzenlenmisGeometriler, false);
            if (!birlesikGeometry) {
                console.warn('[ekranaSigdir] Mesh geometrileri birleştirilemedi');
                return;
            }
            birlesikGeometry.computeBoundingSphere();
            boundingSphere = birlesikGeometry.boundingSphere;
            // console.log('[ekranaSigdir] Mesh bounding sphere:', boundingSphere?.center?.toArray(), 'radius:', boundingSphere?.radius);
        }
        // Her ikisi de varsa, ayrı ayrı hesapla ve birleştir
        else {
            const min = new THREE.Vector3(Infinity, Infinity, Infinity);
            const max = new THREE.Vector3(-Infinity, -Infinity, -Infinity);
            const tempVec = new THREE.Vector3();

            // Mesh geometrileri için
            const duzenlenmisGeometriler = this.normalizeGeometries(geometriler);
            const birlesikGeometry = BufferGeometryUtils.mergeGeometries(duzenlenmisGeometriler, false);
            if (birlesikGeometry) {
                birlesikGeometry.computeBoundingBox();
                if (birlesikGeometry.boundingBox) {
                    min.min(birlesikGeometry.boundingBox.min);
                    max.max(birlesikGeometry.boundingBox.max);
                }
            }

            // Point cloud geometrileri için - world matrix uygulanmış
            for (let g = 0; g < pointCloudGeometriler.length; g++) {
                const pcGeom = pointCloudGeometriler[g];
                const worldMatrix = pointCloudMatrices[g];
                const posAttr = pcGeom.getAttribute('position');
                if (posAttr) {
                    for (let i = 0; i < posAttr.count; i++) {
                        tempVec.set(posAttr.getX(i), posAttr.getY(i), posAttr.getZ(i));
                        tempVec.applyMatrix4(worldMatrix);
                        min.x = Math.min(min.x, tempVec.x);
                        min.y = Math.min(min.y, tempVec.y);
                        min.z = Math.min(min.z, tempVec.z);
                        max.x = Math.max(max.x, tempVec.x);
                        max.y = Math.max(max.y, tempVec.y);
                        max.z = Math.max(max.z, tempVec.z);
                    }
                }
            }

            // Geçerli box varsa sphere oluştur
            if (min.x !== Infinity) {
                const center = new THREE.Vector3().addVectors(min, max).multiplyScalar(0.5);
                const radius = min.distanceTo(max) / 2;
                boundingSphere = new THREE.Sphere(center, radius);
            }
        }
        if (!boundingSphere || boundingSphere.radius === 0) {
            console.warn('[ekranaSigdir] Geçersiz bounding sphere:', boundingSphere);
            return;
        }

        if (!this.anaGosterim?.canvas?.nativeElement) {
            console.warn('[ekranaSigdir] Canvas bulunamadı');
            return;
        }

        const canvasEl = this.anaGosterim.canvas.nativeElement;

        if (canvasEl.clientWidth === 0 || canvasEl.clientHeight === 0) {
            console.warn('[ekranaSigdir] Canvas boyutu 0');
            return;
        }

        const aspect = canvasEl.clientWidth / canvasEl.clientHeight;
        const radius = boundingSphere.radius * (1 + padding);
        const yakinlik = (aspect > 1.0)
            ? canvasEl.clientHeight / (radius * 2)
            : canvasEl.clientWidth / (radius * 2);

        const hedefPoz = boundingSphere.center.clone();
        const oncekiTarget = this.anaGosterim.aktifKontrol.target.clone();
        const kameraYeniPoz = this.anaGosterim.aktifKamera.position.clone().sub(oncekiTarget.clone().sub(hedefPoz));

        // console.log('[ekranaSigdir] Kamera animasyonu başlıyor:', { hedefPoz: hedefPoz.toArray(), yakinlik });
        this.anaGosterim.surekliCiz();

        const kameraPromise = new Promise<void>(resolve => {
            new TWEEN.Tween({
                x: this.anaGosterim.aktifKamera.position.x,
                y: this.anaGosterim.aktifKamera.position.y,
                z: this.anaGosterim.aktifKamera.position.z,
                zoom: this.anaGosterim.aktifKamera.zoom
            })
                .to({
                    x: kameraYeniPoz.x,
                    y: kameraYeniPoz.y,
                    z: kameraYeniPoz.z,
                    zoom: yakinlik
                }, animSuresi)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onUpdate((val) => {
                    this.anaGosterim.aktifKamera.position.set(val.x, val.y, val.z);
                    this.anaGosterim.aktifKamera.zoom = val.zoom;
                    this.anaGosterim.aktifKamera.updateProjectionMatrix();
                })
                .onComplete(() => resolve())
                .start();
        });

        const kontrolPromise = new Promise<void>(resolve => {
            new TWEEN.Tween({
                x: oncekiTarget.x,
                y: oncekiTarget.y,
                z: oncekiTarget.z
            })
                .to({
                    x: hedefPoz.x,
                    y: hedefPoz.y,
                    z: hedefPoz.z
                }, animSuresi)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onUpdate((val) => {
                    this.anaGosterim.aktifKontrol.target.set(val.x, val.y, val.z);
                    this.anaGosterim.aktifKontrol.update();
                })
                .onComplete(() => resolve())
                .start();
        });

        Promise.all([kameraPromise, kontrolPromise])
            .then(() => {
                if (dondur) {
                    const cam = this.anaGosterim.aktifKamera;
                    const kontrol = this.anaGosterim.aktifKontrol;
                    let aci = 0;
                    const dondurAnim = () => {
                        aci += 0.002;
                        cam.position.x = kameraYeniPoz.x * Math.cos(aci) + kameraYeniPoz.z * Math.sin(aci);
                        cam.position.z = kameraYeniPoz.z * Math.cos(aci) - kameraYeniPoz.x * Math.sin(aci);
                        cam.lookAt(kontrol.target);
                        kontrol.update();
                        requestAnimationFrame(dondurAnim);
                    };
                    dondurAnim();
                } else {
                    this.anaGosterim.surekliCizIptal();
                }
            })
            .catch(() => {
                this.anaGosterim.surekliCizIptal();
            });
    }



    ekranaSigdir1(obj?: FikoObje3D) {
        // Eğer obj verilmemişse sahnenin kendisini kullan
        const hedefObj = obj || this;

        let geometriler: THREE.BufferGeometry[] = [];
        hedefObj.traverse((elm: any) => {
            if (elm.type == "FikoCizimYalin") {
                geometriler.push(((elm as FikoCizimYalin).children[0] as THREE.Mesh).geometry)
            }
            if (elm.type == "Mesh") {
                geometriler.push((elm as THREE.Mesh).geometry)
            }
        });

        let buffers = BufferGeometryUtils.mergeGeometries(geometriler);
        // buffers.computeBoundingBox();
        buffers.computeBoundingSphere();

        const boundingSphere = buffers.boundingSphere;
        let aspect = this.anaGosterim.canvas.nativeElement.clientWidth / this.anaGosterim.canvas.nativeElement.clientHeight;

        // this.anaGosterim.aktifKamera.position.copy(boundingSphere.center);
        // this.anaGosterim.aktifKontrol.target.copy(this.anaGosterim.aktifKontrol.target.sub(boundingSphere.center))

        // Animasyon için continuous render başlat
        this.anaGosterim.surekliCiz();

        let yakinlik;
        if (aspect > 1.0) {
            yakinlik = this.anaGosterim.canvas.nativeElement.clientHeight / (boundingSphere.radius * 2)
        }
        else {
            yakinlik = this.anaGosterim.canvas.nativeElement.clientWidth / (boundingSphere.radius * 2)
        }
        // this.anaGosterim.aktifKamera.zoom

        let hedefPoz = boundingSphere.center
        let kEskiPoz = this.anaGosterim.aktifKontrol.target.clone();

        // this.anaGosterim.aktifKontrol.target.copy(hedefPoz.clone())

        let yeniYonPoz = kEskiPoz.sub(hedefPoz)
        let tweenPos = this.anaGosterim.aktifKamera.position.clone().sub(yeniYonPoz)
        // this.anaGosterim.aktifKamera.position.sub(yeniYonPoz)

        const kameraTween1 = new TWEEN.Tween(this.anaGosterim.aktifKamera)
            .to({ zoom: yakinlik, position: { x: tweenPos.x, y: tweenPos.y, z: tweenPos.z } }, 500)
            .onUpdate(() => {
                this.anaGosterim.aktifKamera.updateProjectionMatrix()
            }).easing(TWEEN.Easing.Quadratic.Out)
            .start()


        const kontrolTween1 = new TWEEN.Tween(this.anaGosterim.aktifKontrol)
            .to({ target: { x: hedefPoz.x, y: hedefPoz.y, z: hedefPoz.z } }, 500)
            .onUpdate(() => {
                this.anaGosterim.aktifKontrol.update();
            }).easing(TWEEN.Easing.Quadratic.Out)
            .start()

        // İki TWEEN de bitince continuous render'ı durdur
        Promise.all([
            new Promise<void>(resolve => kameraTween1.onComplete(() => resolve())),
            new Promise<void>(resolve => kontrolTween1.onComplete(() => resolve()))
        ]).then(() => {
            this.anaGosterim.surekliCizIptal();
        });
        /** */

    }


    yuzeySec() {
        // const selam = this.anaGosterim.olayTiklandi.subscribe((olay: any) => {
        //     let odaktaki = olay[0];
        //     if (odaktaki) {
        //         let obje = (odaktaki.object as THREE.Mesh);
        //         let renkler = obje.geometry.getAttribute("color");
        //         let highlightColor = new THREE.Color("red");

        //         for (let index = 0; index < 1; index++) {
        //             obje.geometry.getAttribute("color").setXYZ(odaktaki.face.a + index, highlightColor.r, highlightColor.g, highlightColor.b);
        //             obje.geometry.getAttribute("color").setXYZ(odaktaki.face.b + index, highlightColor.r, highlightColor.g, highlightColor.b);
        //             obje.geometry.getAttribute("color").setXYZ(odaktaki.face.c + index, highlightColor.r, highlightColor.g, highlightColor.b);
        //         }

        //         console.log(odaktaki);

        //         obje.geometry.getAttribute("color").needsUpdate = true;

        //         /** */
        //         // var faceTools = new FikoYTCoplanarUtils({});
        //         // faceTools.onCoplanar = function (r: any) {
        //         //     console.log("onCoplanar", r)
        //         //     for (var i in r) {
        //         //         r[i].color.setHex(0xff0000);
        //         //         odaktaki.object.geometry.colorsNeedUpdate = true;
        //         //     }
        //         // }
        //         // faceTools.getCoplanar(13, odaktaki.object.geometry, odaktaki.face);

        //         /** */

        //         this.anaGosterim.ciz();
        //     }
        //     selam.unsubscribe();
        // });
    }


    noktaSec() {
        // this.anaGosterim.secimModuAktif = true;
        // return new Promise((resolve: any, reject: any) => {
        //     const selam = this.anaGosterim.olayTiklandi.subscribe((olay: any) => {
        //         let odaktaki = olay[0];
        //         if (odaktaki) {
        //             if (odaktaki.object?.type == "Points" || odaktaki.object?.type == "FikoNoktalar") {
        //                 resolve(odaktaki);
        //                 // this.anaGosterim.secimModuAktif = false;
        //             } else {
        //                 reject();
        //                 // this.anaGosterim.secimModuAktif = false;
        //             }
        //         }
        //         selam.unsubscribe();
        //     });
        // });
    }

    // yollar: any[] = [];
    // profil2d: FikoProfil2d = new FikoProfil2d(this);
    // takimYolu: FikoTakimYolu = new FikoTakimYolu();
    cizgiSec() {
        // const selam = this.anaGosterim.olayTiklandi.subscribe((olay: any) => {
        //     let odaktaki = olay[0];
        //     if (odaktaki) {
        //         if (odaktaki.object?.type == "Line") {
        //             //@ts-ignore
        //             (odaktaki.object as THREE.Line).material.color.set(0x0000ff);
        //             //@ts-ignore
        //             // this.yollar = [...this.yollar, ...(odaktaki.object as THREE.Line).geometry.getAttribute("position").array];

        //             let secilenCizgi = (odaktaki.object as THREE.Line);
        //             let lokalSecilenCizgiNoktalar = (odaktaki.object as THREE.Line).geometry.getAttribute("position").array;
        //             let worlSecilenCizgiNoktalar = [];

        //             for (let index = 0; index < lokalSecilenCizgiNoktalar.length / 3; index++) {
        //                 worlSecilenCizgiNoktalar.push(secilenCizgi.localToWorld(new FikoVektor3D(lokalSecilenCizgiNoktalar[index * 3 + 0], lokalSecilenCizgiNoktalar[index * 3 + 1], lokalSecilenCizgiNoktalar[index * 3 + 2])))
        //             }

        //             this.yollar = [...this.yollar, ...worlSecilenCizgiNoktalar];

        //             selam.unsubscribe();

        //             /** SİL:  DENEMEEE */

        //             // console.log(this.yollar)
        //             // this.profil2d.takimYonu = new FikoVektor3D(0, 0, -1);
        //             // this.profil2d.takim.cap = 6.917;
        //             // this.profil2d.ustNokta = new FikoDuzlem(new FikoVektor3D(0, 0, 0));
        //             // let ikidYol: FikoVektor2D[] = []
        //             // for (let index = 0; index < this.yollar.length; index++) {
        //             //     // let ltow = new FikoVektor3D(this.yollar[index].x, this.yollar[index].y, 0);
        //             //     ikidYol.push(new FikoVektor2D(this.yollar[index].x, this.yollar[index].y))
        //             // }
        //             // console.log(ikidYol)
        //             // this.profil2d.profilNoktalar = ikidYol;
        //             // this.profil2d.altNokta = new FikoDuzlem(new FikoVektor3D(0, 0, -10));

        //             // this.profil2d.hesapla();

        //             // this.takimYolu.noktalar = this.profil2d.takimYoluNoktalar;
        //             // this.takimYolu.agactaGorunur = true;




        //             // let nokta = new THREE.SphereGeometry(1, 32, 32);
        //             // let noktamesh = new Mesh(nokta, new MeshBasicMaterial({ color: 0x000000, side: DoubleSide }))
        //             // noktamesh.position.copy(new FikoVektor3D(ikidYol[ikidYol.length - 1].x, ikidYol[ikidYol.length - 1].y, 0));
        //             // this.add(noktamesh)

        //             // nokta = new THREE.SphereGeometry(1, 32, 32);
        //             // noktamesh = new Mesh(nokta, new MeshBasicMaterial({ color: 0x000000, side: DoubleSide }))
        //             // noktamesh.position.copy(new FikoVektor3D(ikidYol[0].x, ikidYol[0].y, 0));
        //             // this.add(noktamesh)

        //             this.add(this.takimYolu)

        //         }
        //     }
        // })
    }

    /**
     * ✅ DEPTEST: Sahne ve seçim sistemini temizle
     * Memory leak'leri önlemek için dispose patternini uygula
     */
    dispose(): void {
        // FikoSecililer sistemini temizle
        if (this.secimler) {
            this.secimler.dispose();
        }

        // Tüm child'ların dispose metodunu çağır
        this.children.forEach((child: any) => {
            if (child.dispose && typeof child.dispose === 'function') {
                child.dispose();
            }
        });
    }


}